import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-red',
    templateUrl: './red.component.html',
    styleUrls: ['./red.component.scss'],
    standalone: false
})
export class RedComponent implements OnInit {

    constructor() {}

    ngOnInit() {}

}
